var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUpSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9906 22C18.0656 22 22.9906 17.075 22.9906 11C22.9906 4.925 18.0656 0 11.9906 0C5.9156 0 0.990601 4.925 0.990601 11C0.990601 17.075 5.9156 22 11.9906 22ZM15.2836 13.207C15.4722 13.3892 15.7248 13.49 15.987 13.4877C16.2492 13.4854 16.5 13.3802 16.6854 13.1948C16.8708 13.0094 16.976 12.7586 16.9783 12.4964C16.9806 12.2342 16.8798 11.9816 16.6976 11.793L12.6976 7.793C12.5101 7.60553 12.2558 7.50021 11.9906 7.50021C11.7254 7.50021 11.4711 7.60553 11.2836 7.793L7.2836 11.793C7.10144 11.9816 7.00065 12.2342 7.00293 12.4964C7.0052 12.7586 7.11037 13.0094 7.29578 13.1948C7.48119 13.3802 7.732 13.4854 7.9942 13.4877C8.2564 13.49 8.509 13.3892 8.6976 13.207L11.9906 9.914L15.2836 13.207Z",
    fill: "#CF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpSidebar);
export default __webpack_public_path__ + "static/media/Chevron-Up-Sidebar.41a32fdebbb466a84d73b84e492bfeec.svg";
export { ForwardRef as ReactComponent };